import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISupporterSendChatClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterSendChatClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/send_chat`;

export class SupporterSendChatClient implements ISupporterSendChatClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, chat_room_id, message } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ chat_room_id: chat_room_id, message: message });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
